import React, { useEffect, useState } from "react";

import TrmsCtxtInqApi from "Apis/TrmsCtxtInqApi";
import TrmsLstInqApi from "Apis/TrmsLstInqApi";

import "Assets/css/Trms.css";
import { useLocation, useNavigate } from "react-router-dom";
import MgpStore from "Stores/Store";
import UseLangLstQuery from "Apis/LangTxtInqApi";

const TrmsCtxtUi = ({gameSvcCd,trmsKindCd}:any) => {
    const {isLoading,error,data: langData}:any = UseLangLstQuery();
    const location = useLocation();
    const navigate = useNavigate();
    
    // URL 파라미터 실시간 추출 (탭 변경 및 브라우저 네비게이션 감지용)
    const getCurrentParams = () => {
        const currentParams = new URLSearchParams(location.search);
        return {
            currentGameSvcCd: currentParams.get("gameSvcCd") || gameSvcCd,
            currentTrmsKindCd: currentParams.get("trmsKindCd") || trmsKindCd,
            currentLang: currentParams.get("lang") || MgpStore.getState().LangSetState.Lang
        };
    };
    
    // 탭 변경 시 URL 파라미터 업데이트
    const handleTabChange = (newTrmsKindCd: string) => {
        const { currentGameSvcCd, currentLang } = getCurrentParams();
        const newParams = new URLSearchParams(location.search);
        newParams.set("trmsKindCd", newTrmsKindCd);
        newParams.set("gameSvcCd", currentGameSvcCd);
        newParams.set("lang", currentLang);
        navigate(`${location.pathname}?${newParams.toString()}`, { replace: true });
    };

    // 언어 변경 또는 페이지 로드 시 URL 파라미터 동기화
    const syncUrlWithCurrentState = () => {
        const { currentGameSvcCd, currentTrmsKindCd } = getCurrentParams();
        const currentLang = MgpStore.getState().LangSetState.Lang;
        const newParams = new URLSearchParams(location.search);
        newParams.set("gameSvcCd", currentGameSvcCd);
        newParams.set("trmsKindCd", currentTrmsKindCd);
        newParams.set("lang", currentLang);
        // /Trms 경로에서만 URL 파라미터 업데이트
        if (location.pathname.startsWith("/Trms")) {
            const currentUrl = `${location.pathname}?${newParams.toString()}`;
            const actualUrl = `${location.pathname}${location.search}`;
            if (currentUrl !== actualUrl) {
                navigate(currentUrl, { replace: true });
            }
        }
    };
    
    const serchParamsFunc = () => {
        return new URLSearchParams(location.search);
    }
    let query =serchParamsFunc();
    let getGameSvcCd = query.get("gameSvcCd");
    
    let getTrmsKindCd = query.get("trmsKindCd");
    if(getGameSvcCd !=null){
        gameSvcCd = getGameSvcCd;
    }
    if(getTrmsKindCd != null) {
        trmsKindCd = getTrmsKindCd;
    }

    if(gameSvcCd ==null) {
        gameSvcCd = location.state?.gameSvcCd;
    }
    if(trmsKindCd ==null) {
        trmsKindCd = location.state?.trmsKindCd;
    }

    const [trmsKindCdState,setTrmsKindCdState] = useState(trmsKindCd);
    const [trmsKindDescState,setTrmsKindDescState] = useState<string>();
    const [trmsCtxt,setTrmsCtxt] = useState<any>();
    const [trmsHisList,setTrmsHisList] = useState<any>();
    const [currentGameSvcCd,setCurrentGameSvcCd] = useState(gameSvcCd); // 현재 사용중인 gameSvcCd 추적
    const [isInitialized, setIsInitialized] = useState(false); // 초기화 상태 추가
    const [isMobileCategoryOpen, setIsMobileCategoryOpen] = useState(false);
    const [isInModal, setIsInModal] = useState(false); // 모달 내부 여부
    const normalizeFontColor = (html: string) =>
        html
            .replace(/<font([^>]*?)color=["']?([^"'>\s]+)["']?([^>]*?)>/gi, '<span$1$3 style="color:$2;">')
            .replace(/<\/font>/gi, '</span>');
    const TrmsDescChngFunc = (trmsKindCd:string)=>{
        switch(trmsKindCd){
            case "TRMS_USE":
                setTrmsKindDescState(langData&&langData.GLB_FTR_SVC_TRMS_BTN_00);
                //이용약관
            break;
            case "TRMS_PRV_PLC":
                setTrmsKindDescState(langData&&langData.GLB_FTR_PRIVACY_MAIN_BTN_00);
                //개인정보처리방침
            break;
            case "TRMS_UTH_PLC":
                setTrmsKindDescState(langData&&langData.GLB_TRMS_UTH_PLC_TITL_00);
                //청소년보호정책
            break;
            case "TRMS_OPR_PLC":
                setTrmsKindDescState(langData&&langData.GLB_TRMS_OPR_PLC_TITL_00);
                //운영정책
            break;
            case "TRMS_MNY_USE":
                setTrmsKindDescState(langData&&langData.GLB_TRMS_TRM_MNY_TITL_00);
                //게임재화이용약관
            break;
            case "TRMS_TRNSF_ABRD":
                setTrmsKindDescState(langData && langData.GLB_TRMS_TRNSF_ABRD_TITL_00 ? langData.GLB_TRMS_TRNSF_ABRD_TITL_00 : "개인정보의 제3자 제공 및 국외 이전 동의");
                //개인정보 제3자 제공 및 국외 이전 동의
            break;
            case "TRMS_MKTG":
                setTrmsKindDescState(langData && langData.GLB_TRMS_TRNSF_ABRD_TITL_00 ? langData.GLB_TRMS_TRNSF_ABRD_TITL_00 : "개인정보의 제3자 제공 및 국외 이전 동의");
                //개인정보 제3자 제공 및 국외 이전 동의
            break;
            default:
                setTrmsKindDescState(langData&&langData.GLB_FTR_SVC_TRMS_BTN_00);
            break;
        }
    }
    useEffect(()=>{
        // 이미 초기화되었고 langData가 없다면 실행하지 않음
        if (isInitialized && !langData) return;
        
        // URL 파라미터와 현재 상태 동기화
        syncUrlWithCurrentState();
        
        const { currentGameSvcCd, currentTrmsKindCd, currentLang } = getCurrentParams();
        console.log("API 호출 - gameSvcCd:", currentGameSvcCd, "trmsKindCd:", currentTrmsKindCd, "lang:", currentLang);
        
        setTrmsKindCdState(currentTrmsKindCd);
        switch(currentTrmsKindCd){
            case "TRMS_USE":
                setTrmsKindDescState(langData&&langData.GLB_FTR_SVC_TRMS_BTN_00);
                //이용약관
            break;
            case "TRMS_PRV_PLC":
                setTrmsKindDescState(langData&&langData.GLB_FTR_PRIVACY_MAIN_BTN_00);
                //개인정보처리방침
            break;
            case "TRMS_UTH_PLC":
                setTrmsKindDescState(langData&&langData.GLB_TRMS_UTH_PLC_TITL_00);
                //청소년보호정책
            break;
            case "TRMS_OPR_PLC":
                setTrmsKindDescState(langData&&langData.GLB_TRMS_OPR_PLC_TITL_00);
                //운영정책
            break;
             case "TRMS_TRNSF_ABRD":
                setTrmsKindDescState(langData && langData.GLB_TRMS_TRNSF_ABRD_TITL_00 ? langData.GLB_TRMS_TRNSF_ABRD_TITL_00 : "개인정보의 제3자 제공 및 국외 이전 동의");
                //개인정보 제3자 제공 및 국외 이전 동의
            break;
            case "TRMS_MNY_USE":
                setTrmsKindDescState(langData&&langData.GLB_TRMS_TRM_MNY_TITL_00);
                //게임재화이용약관
            break;
            default:
                setTrmsKindDescState(langData&&langData.GLB_FTR_SVC_TRMS_BTN_00);
            break;
        }
        TrmsLstInqApi(currentGameSvcCd,currentTrmsKindCd)
        .then((Resp) => {
            // trmsHisList가 null이거나 빈 배열인 경우 MGP로 재요청
            if (!Resp.apiBody.trmsHisList || Resp.apiBody.trmsHisList.length === 0) {
                if (currentGameSvcCd !== "MGP") {
                    return TrmsLstInqApi("MGP", currentTrmsKindCd).then(mgpResp => ({
                        ...mgpResp,
                        usedGameSvcCd: "MGP" // fallback된 gameSvcCd 추가
                    }));
                }
            }
            return { ...Resp, usedGameSvcCd: currentGameSvcCd }; // 원래 gameSvcCd 추가
        })
        .then((Resp) => {
            setTrmsHisList(Resp.apiBody.trmsHisList);
            setCurrentGameSvcCd(Resp.usedGameSvcCd); // 현재 사용중인 gameSvcCd 업데이트
            if (Resp.apiBody.trmsHisList && Resp.apiBody.trmsHisList.length > 0) {
                TrmsCtxtInqApi(Resp.usedGameSvcCd, currentTrmsKindCd, Resp.apiBody.trmsHisList[0].trmsHisDtime)
                .then((Resp) => {
                    const dirty = Resp.apiBody.trmsCtxt;
                    setTrmsCtxt(normalizeFontColor(dirty));
                });
            }
        });
        setIsInitialized(true); // 초기화 완료 표시
    },[location.search, langData, MgpStore.getState().LangSetState.Lang]); // URL 변경과 언어 변경 감지
    
    // 모달 내부 여부 감지
    useEffect(() => {
        const checkIfInModal = () => {
            let current = document.querySelector('.trmsMobileWrapper')?.parentElement;
            let inModal = false;
            let debugPath = [];
            
            for (let i = 0; i < 10 && current; i++) {
                const classes = current.className || '';
                debugPath.push(current.tagName + '.' + classes);
                if (/mdal|modal|popup|dialog|drawer|bottom-sheet/i.test(classes)) {
                    inModal = true;
                    break;
                }
                current = current.parentElement;
            }
            
            console.log('[TrmsCtxtUi] Modal detection - inModal:', inModal, 'path:', debugPath);
            setIsInModal(inModal);
        };
        
        checkIfInModal();
        const timer = setTimeout(checkIfInModal, 100);
        return () => clearTimeout(timer);
    }, []);
    
    const TrmsChngFunc = (trmsKindCd:string) => {
        // URL 파라미터 업데이트 - useEffect에서 자동으로 API 호출됨
        handleTabChange(trmsKindCd);
    }
    const HisDtimeChngFunc = (event:any) =>{
        TrmsCtxtInqApi(currentGameSvcCd, trmsKindCdState, event.target.value)
            .then((Resp) => {
                const dirty = Resp.apiBody.trmsCtxt;
                setTrmsCtxt(normalizeFontColor(dirty));
            }); 
    }
    return(
        <div className="BgW trmsBgW ">
            <div className="csMainBnr">
                <h1>{langData&&langData.GLB_TRMS_CTXT_TITL_00}</h1>
                <p>Terms of Use and Operational Policies</p>
            </div>
            <div className="trmsContainer">
                <h1 className="trmsCtgrTitl">{langData&&langData.GLB_TRMS_CTXT_TITL_00}</h1>
                {/* Desktop category menu (hidden on mobile) */}
                <div className="trmsCtgrMenu">
                    <ul>
                        <li className={trmsKindCdState == "TRMS_USE"?"active onClickLi":"onClickLi"} onClick={() => TrmsChngFunc("TRMS_USE")}>
                            <p>{langData&&langData.GLB_FTR_SVC_TRMS_BTN_00}</p>
                        </li>
                        <li className={trmsKindCdState == "TRMS_PRV_PLC"?"active onClickLi":"onClickLi"} onClick={() => TrmsChngFunc("TRMS_PRV_PLC")}>
                            <p>{langData&&langData.GLB_FTR_PRIVACY_MAIN_BTN_00}</p>
                        </li>
                        <li className={trmsKindCdState == "TRMS_UTH_PLC"?"active onClickLi":"onClickLi"} onClick={() => TrmsChngFunc("TRMS_UTH_PLC")}>
                            <p>{langData&&langData.GLB_TRMS_UTH_PLC_TITL_00}</p>
                        </li>
                        <li className={trmsKindCdState == "TRMS_OPR_PLC"?"active onClickLi":"onClickLi"} onClick={() => TrmsChngFunc("TRMS_OPR_PLC") }>
                            <p>{langData&&langData.GLB_TRMS_OPR_PLC_TITL_00}</p>
                        </li>
                    </ul>
                </div>

                {/* Mobile toggle + bottom-sheet menu */}
                <div className="trmsMobileWrapper">
                    <button className={`mobileCategoryBtn trmsMobileToggle ${isInModal ? 'in-modal' : ''}`} onClick={() => setIsMobileCategoryOpen(prev => !prev)} aria-expanded={isMobileCategoryOpen}>
                        <span>{trmsKindCdState === 'TRMS_USE' ? (langData && langData.GLB_FTR_SVC_TRMS_BTN_00) :
                            trmsKindCdState === 'TRMS_PRV_PLC' ? (langData && langData.GLB_FTR_PRIVACY_MAIN_BTN_00) :
                            trmsKindCdState === 'TRMS_UTH_PLC' ? (langData && langData.GLB_TRMS_UTH_PLC_TITL_00) :
                            (langData && langData.GLB_TRMS_OPR_PLC_TITL_00)
                        }</span>
                        <span className={`category-arrow ${isMobileCategoryOpen ? 'up' : 'down'}`}></span>
                    </button>

                    {isMobileCategoryOpen && (
                        <div className={`trmsMobileOverlay ${isInModal ? 'in-modal' : ''}`} onClick={() => setIsMobileCategoryOpen(false)} />
                    )}

                    <div className={`trmsCtgrMobileWrap ${isMobileCategoryOpen ? 'open' : ''} ${isInModal ? 'in-modal' : ''}`}>
                        <ul>
                            <li onClick={() => { TrmsChngFunc('TRMS_USE'); setIsMobileCategoryOpen(false); }} className={trmsKindCdState === 'TRMS_USE' ? 'active' : ''}><p>{langData && langData.GLB_FTR_SVC_TRMS_BTN_00}</p></li>
                            <li onClick={() => { TrmsChngFunc('TRMS_PRV_PLC'); setIsMobileCategoryOpen(false); }} className={trmsKindCdState === 'TRMS_PRV_PLC' ? 'active' : ''}><p>{langData && langData.GLB_FTR_PRIVACY_MAIN_BTN_00}</p></li>
                            <li onClick={() => { TrmsChngFunc('TRMS_UTH_PLC'); setIsMobileCategoryOpen(false); }} className={trmsKindCdState === 'TRMS_UTH_PLC' ? 'active' : ''}><p>{langData && langData.GLB_TRMS_UTH_PLC_TITL_00}</p></li>
                            <li onClick={() => { TrmsChngFunc('TRMS_OPR_PLC'); setIsMobileCategoryOpen(false); }} className={trmsKindCdState === 'TRMS_OPR_PLC' ? 'active' : ''}><p>{langData && langData.GLB_TRMS_OPR_PLC_TITL_00}</p></li>
                        </ul>
                    </div>
                </div>
                <div className="trmsCtxtWrap">
                    <div className="trmsHisList">
                        <h1>{trmsKindDescState&&trmsKindDescState}</h1>
                        <select name="trmsHisList" id="trmsHisList" onChange={HisDtimeChngFunc}>
                            {trmsHisList&&trmsHisList.map((key:any) => (
                                <option value={key.trmsHisDtime}><p>{key.trmsHisDay}</p></option>
                            ))}
                        </select>
                    </div>
                    {trmsCtxt != null?
                        <div className="trmsCtxt" 
                        dangerouslySetInnerHTML={{
                            __html: trmsCtxt,
                        }}>
                        </div>    
                    :
                    <></>
                    }
                </div>
            </div>
        </div>
    )
}

export default TrmsCtxtUi
